import React from 'react';
import {
  Box,
  Paper,
  IconButton,
  Tooltip,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Receipt as ReceiptIcon,
  PersonAdd as PersonAddIcon,
  Inventory as InventoryIcon,
  Business as BusinessIcon,
  Assessment as AssessmentIcon,
  Settings as SettingsIcon,
  Description as DescriptionIcon,
  Folder as FolderIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const QuickAccessPanel = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const quickAccessItems = [
    {
      icon: <ReceiptIcon />,
      label: 'New Invoice',
      path: '/sales/new-invoice',
      color: '#4361ee',
    },
    {
      icon: <PersonAddIcon />,
      label: 'New Customer',
      path: '/customers/new',
      color: '#3f37c9',
    },
    {
      icon: <BusinessIcon />,
      label: 'New Supplier',
      path: '/suppliers/new',
      color: '#4895ef',
    },
    {
      icon: <InventoryIcon />,
      label: 'New Item',
      path: '/items/new',
      color: '#4cc9f0',
    },
    {
      icon: <DescriptionIcon />,
      label: 'New Purchase',
      path: '/purchases/new',
      color: '#f72585',
    },
    {
      icon: <AssessmentIcon />,
      label: 'Reports',
      path: '/reports',
      color: '#7209b7',
    },
    {
      icon: <FolderIcon />,
      label: 'Documents',
      path: '/documents',
      color: '#3a0ca3',
    },
    {
      icon: <SettingsIcon />,
      label: 'Settings',
      path: '/settings',
      color: '#4a4e69',
    },
  ];

  const getIconSize = () => {
    if (isMobile) return 40;
    if (isTablet) return 50;
    return 60;
  };

  const getGridSize = () => {
    if (isMobile) return 3;
    if (isTablet) return 4;
    return 3;
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        {quickAccessItems.map((item, index) => (
          <Grid item xs={6} sm={4} md={getGridSize()} key={index}>
            <Tooltip title={item.label} placement="top">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  cursor: 'pointer',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    transition: 'transform 0.2s',
                  },
                }}
                onClick={() => navigate(item.path)}
              >
                <Paper
                  elevation={0}
                  sx={{
                    width: getIconSize(),
                    height: getIconSize(),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: `${item.color}15`,
                    borderRadius: '12px',
                    mb: 1,
                    border: `1px solid ${item.color}30`,
                    transition: 'all 0.2s',
                    '&:hover': {
                      bgcolor: `${item.color}25`,
                      boxShadow: `0 4px 12px ${item.color}30`,
                    },
                  }}
                >
                  <IconButton
                    sx={{
                      color: item.color,
                      '&:hover': {
                        bgcolor: `${item.color}20`,
                      },
                    }}
                  >
                    {item.icon}
                  </IconButton>
                </Paper>
                <Typography
                  variant="caption"
                  sx={{
                    textAlign: 'center',
                    fontWeight: 500,
                    color: 'text.secondary',
                    fontSize: '0.75rem',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            </Tooltip>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default QuickAccessPanel; 